import { useState, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import cn from 'classnames';

import styles from './styles.module.scss';
import Touch from '../PositionControl/Touch';

const TRACK_BOTTOM_OFFSET = 80;

const yToPercent = (y, height) =>
  Math.max(0, Math.min(100, Number((((height - TRACK_BOTTOM_OFFSET - y) * 100) / (height - TRACK_BOTTOM_OFFSET)).toFixed())));

const MotorControl = ({ percent, setPercent, isSecond, onFirstDrag }) => {
  const [values, setValues] = useState({ x: 40, y: 370 });
  const parentRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const onDragStart = (e) => {
    if (e.target.className.includes('touch')) {
      setDragging(true);
    }
  };

  const onDragging = (e) => {
    if (!dragging || !parentRef.current) {
      return;
    }
    const parentPos = parentRef.current.getBoundingClientRect();
    const clientY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
    const y = Math.max(0, Math.min(parentPos.height - TRACK_BOTTOM_OFFSET, clientY - parentPos.top));
    setValues((prev) => ({ ...prev, y }));
    setPercent(yToPercent(y, parentPos.height));
    onFirstDrag();
  };

  const onDragEnd = () => setDragging(false);

  const mobileProps = {
    onTouchEnd: onDragEnd,
    onTouchStart: onDragStart,
    onTouchMove: onDragging,
    onTouchCancel: onDragEnd,
  };
  const desktopProps = {
    onPointerLeave: onDragEnd,
    onPointerDown: onDragStart,
    onPointerMove: onDragging,
    onPointerUp: onDragEnd,
  };
  const dragEventProps = isMobile ? mobileProps : desktopProps;

  return (
    <div className={styles.motorColumn}>
      <div ref={parentRef} className={styles.motorTrack} {...dragEventProps}>
        <Touch
          values={values}
          intensity={percent}
          isTooltipsVisible={false}
          circleClassName={isSecond ? styles.secondCircle : undefined}
        />
      </div>
      <div className={cn(styles.intensityLabel, styles._100)}>100%</div>
      <div className={cn(styles.intensityLabel, styles._0)}>0%</div>
    </div>
  );
};

const PowerShotController = ({ firstMotorPercent, setFirstMotorPercent, secondMotorPercent, setSecondMotorPercent }) => {
  const [isTooltipVisible, setTooltipVisible] = useState(true);

  const hideTooltip = () => {
    if (isTooltipVisible) {
      setTooltipVisible(false);
    }
  };

  return (
    <div className={styles.container}>
      {isTooltipVisible && (
        <div className={styles.tooltip}>
          Swipe up and down to <span className={styles.tooltipSub}>control the intensity</span>
        </div>
      )}
      <MotorControl percent={firstMotorPercent} setPercent={setFirstMotorPercent} onFirstDrag={hideTooltip} />
      <MotorControl percent={secondMotorPercent} setPercent={setSecondMotorPercent} isSecond onFirstDrag={hideTooltip} />
    </div>
  );
};

export default PowerShotController;
